// eslint-disable-next-line
import React, { Component } from "react";
import "./venta.scss";
import { Col, Container, Row } from 'bootstrap-4-react';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import ItemsCarousel from 'react-items-carousel';
import Lottie from 'lottie-react-web'
import animationData from "../../../lotties/33623-piggy-bank-loop.json";

import TimeAgo from 'react-timeago'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import Modal from 'react-modal'


const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
const customStyles = {
  control: styles => ({ ...styles, backgroundColor: '#fff', height: 42, width: '90%', margin: '0 auto', marginBottom: 20, }),
}
const formatter = buildFormatter(spanishStrings)


class MainProgresoPage extends Component {
  constructor(props) {
    super(props);
    this.__getProgreso = this.__getProgreso.bind(this)
    this.state = {
      __getProgreso: this.__getProgreso,
      pleaseUpdate: 0,
      arraySucursales: [],
      id_sucursal: '0',
      date: moment().format('YYYY-MM-DD'),
      typeProduct: 0,
      arrDiasVenta: [],
      arrDiasGasto: [],
      arrHistoryVentas: [],
      totalVentas: {
        kg: 0,
        pesos: 0,
        pesosMesAnterior: 0,
      },
      totalGastos: {
        gastos: 0,
      },
      isLoading: false,
      groupBy: 'sucursal',
      indexViewProducts: -1,

      //Carousel items
      children: [],
      activeItemIndex: 0,

      arrFiltroVer: [
        { optFiltroVer: 'dia', value: 'Día', active: 1, },
        { optFiltroVer: 'semana', value: 'Semana', active: 0, },
        { optFiltroVer: 'mes', value: 'Mes', active: 0, },
      ],

      finit: moment().format('YYYY-MM-DD'),
      ffin: moment().format('YYYY-MM-DD'),
      valueLarge: { min: 1, max: 30 },

      //Envíos a sucursales
      arrTraspasosPendientes: [],
      arrTraspasosConfirmados: [],
      arrGastosFinancieros: [],
      indexTraspasoView: -1,
      indexConfirmadosView: -1,

      arrGFinancieroNew: {},
      arrConceptosGFinancieros: [],

    }
  }

  __getProgreso() {
    //this.getProgreso()
    this.setState({
      pleaseUpdate: 1,
    })
  }

  getDateGeneric(opt) {
    if(opt === 0)
      return (new Date())
    else {
      let d = new Date()
      // d.setMonth(5) // Junio
      // d.setDate(30)
      return new Date(d)
    }

  }

  componentDidMount() {
    //Petition wuuuu
    this.getProgreso()
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  getProgreso() {

    const { id_sucursal, date, typeProduct, groupBy, finit, ffin, } = this.state

    const data = {
      user: 'admin',
      tab: this.props.initState.tabProgresoActive,
      id_sucursal,
      date,
      typeProduct,
      groupBy,

      finit,
      ffin,
    }

    this.setState({ pleaseUpdate: 2, })
    this.goToDay(data)
  }

  handleInputChange(data) {
    this.setState({ id_sucursal: data.id_sucursal });
    setTimeout( () => {
      this.getProgreso()
    }, 100)
  }

  getAmountByDay(type) {
    let { date, arrDiasVenta, arrDiasGasto, } = this.state
    const dia = moment(date).format('DD')

    if(arrDiasVenta.length === 0)
      return 0

    // if(typeof arrDiasVenta[ dia - 1 ] === 'undefined')
    //   return this.number_format( 0, 2 );

    if(type === 'venta') {
      return this.number_format( arrDiasVenta[ dia - 1 ].venta_pesos, 2 )
    } else if(type === 'gasto') {
      return this.number_format( arrDiasGasto[ dia - 1 ].valor, 2 )
    } else if(type === 'utilidad') {
      return this.number_format( arrDiasVenta[ dia - 1 ].venta_pesos - arrDiasGasto[ dia - 1 ].valor, 2 )
    }

    return 0
  }

  changeActiveItem(activeItemIndex) {
    this.setState({ activeItemIndex });
  }

  render() {
    const { arraySucursales, date, totalVentas, isLoading, groupBy, arrHistoryVentas, arrFiltroVer, finit, ffin, valueLarge,
      arrTraspasosPendientes, indexTraspasoView, indexConfirmadosView, arrTraspasosConfirmados, arrGastosFinancieros, 
      arrGFinancieroNew, arrConceptosGFinancieros,

    } = this.state
    const porcMeta = this.getProgressMeta()
    const { RTDirector, signedIn, } = this.props.initState

    if(!this.state.arrHistoryVentas.list && signedIn.id_usuario !== 'wiwi00_adm') {
      return (
        <div className="directorPage__wrapper" style={{ marginTop: 20, }}>
          <Lottie
            direction={1}
            options={{
              animationData: animationData,
              loop: true,
            }}
          />
        </div>
      )
    }

    const utilidad = ((arrHistoryVentas.total + arrHistoryVentas.abonos) - (arrHistoryVentas.total_pcompra)) - arrHistoryVentas.gastos
    let gFinancieroTotal = 0
    let gFinancieroSinFactura = 0

    arrGastosFinancieros.map((t) => {
      if(t.facturado === 0)
        gFinancieroSinFactura += parseFloat(t.cantidad);

      gFinancieroTotal += parseFloat( t.cantidad )
    })

    arrHistoryVentas.list.map((t) => {
      if(typeof t.gastos !== 'undefined' && t.gastos)
        gFinancieroTotal += parseFloat( t.gastos )
    })

    return (
      <div className="directorPage__wrapper" style={{ borderRadius: '' }}>
        {/* Principal div */}
        <Container>
          <Row>
            <div className="initialPage__principalContainer" style={{ backgroundColor: 'transparent', }}>
              <h2 style={{ fontWeight: '300', color: '#b71540', paddingBottom: 10, }}>Dashboard</h2>
              {
                RTDirector.text != '' ? (
                  <p className={'ws-banner-inventa'}><b>{RTDirector.text}</b></p>
                ) : (
                <>
                  {
                    this.state.pleaseUpdate === 1 ? (
                      <p onClick={() => { this.setState({ pleaseUpdate: 2, }, this.getProgreso) }} className={'ws-banner-plaseupdate'}><b>Se han realizado nuevas ventas, por favor pulsa para actualizar</b></p>
                    ) : null
                  }
                  {
                    this.state.pleaseUpdate === 2 ? (
                      <p className={'ws-banner-updating'}><b>Actualizando tus ventas...</b></p>
                    ) : null
                  }
                </>
                )
              }
              <Row style={{ marginTop: 5, }}>{
                arrFiltroVer.map((t, e) => (
                  <Col>
                    <p
                      style={{
                        padding: '5px 10px', marginTop: 15, cursor: 'pointer', textAlign: 'center', borderRadius: '4px', fontWeight: 600, width: '100%', margin: '4px 0',
                        background: t.active === 1 ? 'rgb(183, 21, 64)' : 'transparent', border: t.active === 1 ? '0px' : '1px solid rgb(183, 21, 64)',
                        color: t.active === 1 ? '#fff' : 'rgb(183, 21, 64)',
                      }}
                      onClick={ () => {
                        this.onChangeFiltroVer(t,e)
                      }} className="regVentaPage__title">{t.value}
                    </p>
                  </Col>
                ))
              }</Row>

              <Row>
                <Col>
                  <p style={{ margin: 0, }}>Desde</p>
                  <input type={"date"}
                    value={finit}
                    onChange={(event) => {
                      arrFiltroVer.map(( t => t.active = 0) );
                      this.setState({ finit: event.target.value, arrFiltroVer });
                    }}
                    style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: 0, width: '100%', }}
                  />
                </Col>
                {
                  arrFiltroVer[0].active != 1 ? (
                    <Col>
                      <p style={{ margin: 0, }}>Hasta</p>
                      <input type={"date"}
                        value={ffin}
                        onChange={(event) => {
                          arrFiltroVer.map(( t => t.active = 0) );
                          valueLarge.max = event.target.value
                          this.setState({ ffin: event.target.value,
                            arrFiltroVer,
                            valueLarge,

                          });
                        }}
                        style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: 0, width: '100%', }}
                      />
                    </Col>
                  ) : null
                }
              </Row>
              <Row>
                <Col style={{textAlign: 'right'}}>
                  <button style={{ margin: 0, marginTop: 5, border: 0, background: 'rgb(183, 21, 64)', }} className={'btn btn-primary'} onClick={() => { this.getProgreso() }}>Generar</button>
                </Col>
              </Row>

              <p className={'initialPage__separatorTitle'}>Acumulado mensual</p>
              <Row>
                <Col style={{ textAlign: 'center', marginTop: 5, }}>
                  <p style={{ fontWeight: '800', margin: 0, fontSize: '1.3rem', }}>${ this.number_format(totalVentas.total_venta_mes, 2) }</p>
                  <p style={{ color: '#777', }}>Ventas</p>
                </Col>
                <Col style={{ textAlign: 'center', marginTop: 5, }}>
                  <p style={{ fontWeight: '800', margin: 0, fontSize: '1.3rem', }}>${this.number_format(totalVentas.total_gasto_proveedor + totalVentas.total_gasto_mes, 2)}</p>
                  <p style={{ color: '#777', }}>Gastos (op + prov)</p>
                </Col>
              </Row>

              <Row>

                <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid #da3a2f', border: '3px solid rgba(0,0,0,0.2)' }}>
                  <p><b style={{ fontSize: '1.3rem', color: '#606060', fontWeight: 400 }}>Venta</b></p>
                  <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${ this.number_format(arrHistoryVentas.total,2) }</b></p>
                  <p><b style={{ fontWeight: '500', color: '#444', fontSize: '.9rem' }}>${ this.number_format(arrHistoryVentas.total_ant,2) }</b></p>
                </Col>
                <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid #da3a2f', border: '3px solid rgba(0,0,0,0.2)' }}>
                  <p><b style={{ fontSize: '1.3rem', color: '#606060', fontWeight: 400 }}>Compra</b></p>
                  <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${ this.number_format(arrHistoryVentas.total_pcompra,2) }</b></p>
                  <p><b style={{ fontWeight: '500', color: '#444', fontSize: '.9rem' }}>${ this.number_format(arrHistoryVentas.total_pcompra_ant,2) }</b></p>
                </Col>
                <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid black', border: '3px solid rgba(0,0,0,0.2)' }}>
                  <p><b style={{ fontSize: '1.3rem', color: '#606060', fontWeight: 400 }}>Gastos</b></p>
                  <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${ this.number_format(arrHistoryVentas.gastos,2) }</b></p>
                  <p><b style={{ fontWeight: '500', color: '#444', fontSize: '.9rem' }}>${ this.number_format(arrHistoryVentas.gastos_ant,2) }</b></p>
                </Col>
              </Row>
              <Row>
                <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid green', border: '3px solid rgba(0,0,0,0.2)' }}>
                  <p><b style={{ fontSize: '1.3rem', color: '#606060', fontWeight: 400 }}>Meta Valles</b></p>
                  <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${ this.number_format( (this.makeInfoMetasValles()) ,2) }</b></p>
                </Col>
                <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid green', border: '3px solid rgba(0,0,0,0.2)' }}>
                  <p><b style={{ fontSize: '1.3rem', color: '#606060', fontWeight: 400 }}>Utilidad</b></p>
                  <p><b style={{ fontSize: '.8rem', color: '#606060', fontWeight: 400 }}>(V + Ab - C - G)</b></p>
                  <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${ this.number_format( utilidad ,2) }</b></p>
                </Col>
              </Row>
              <Row>
                <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid green', border: '3px solid rgba(0,0,0,0.2)' }}>
                  <div className={'btn__addNewGasto'} onClick={ () => { this.setState({ isOpenGastoFinanciero: true, }) }}><b>+</b></div>
                  <p><b style={{ fontSize: '1.3rem', color: '#606060', fontWeight: 400 }}>Caja chica</b></p>
                  <p><b style={{ fontSize: '.8rem', color: '#606060', fontWeight: 400 }}>(Cch + G prov)</b></p>
                  <p onClick={() => { this.setState({ isOpenListFinanciero: true, }) }}><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${ this.number_format( gFinancieroTotal ,2) }</b></p>
                </Col>
                <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid green', border: '3px solid rgba(0,0,0,0.2)' }}>
                  <p><b style={{ fontSize: '1.3rem', color: '#606060', fontWeight: 400 }}>Sin facturar</b></p>
                  <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${ this.number_format( gFinancieroSinFactura ,2) }</b></p>
                </Col>
                <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid green', border: '3px solid rgba(0,0,0,0.2)' }}>
                  <p><b style={{ fontSize: '1.3rem', color: '#606060', fontWeight: 400 }}>Utilidad neta</b></p>
                  <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${ this.number_format( utilidad - gFinancieroTotal ,2) }</b></p>
                </Col>
              </Row>

              <ItemsCarousel
                enablePlaceholder={false}
                numberOfPlaceholderItems={4}
                minimumPlaceholderTime={1000}
                placeholderItem={<div style={{ height: 200, background: '#900' }}></div>}
                numberOfCards={2}
                gutter={10}
                showSlither={true}
                firstAndLastGutter={true}
                freeScrolling={false}
                requestToChangeActive={ (index) => {this.changeActiveItem(index)} }
                activeItemIndex={this.state.activeItemIndex}
                activePosition={'center'}
                chevronWidth={10}
                rightChevron={<button className={'btn__itemcarouselChevron'}>{'>'}</button>}
                leftChevron={<button className={'btn__itemcarouselChevron'}>{'<'}</button>}
                outsideChevron={false}
                >
                {
                (this.state.arrHistoryVentas.list) && this.state.arrHistoryVentas.list.map((t,e) => (
                  <div className={'directorPage__carousel_container'} onClick={() => { this.onInfoBySucursal(t,e) }} key={1} style={{ background: this.getColorByIndex(e) }}>
                    <div className={'directorPage__carousel_utilidad'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format( (t.total - t.total_pcompra) - t.gastos_fijos , 2)}`}</p>
                      <p className={'directorPage__carousel_text'}>Utilidad ({ `${ this.number_format((t.utilidad / t.total) * 100, 2) }%` })</p>
                      <div className={'directorPage__carousel_progressBar'}>
                        <div style={{ background: '#2ed573', width: `${ this.number_format((t.utilidad / t.total) * 100, 2) }%` }}></div>
                      </div>
                    </div>
                    <div className={'directorPage__carousel_total'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.total, 2)}`}</p>
                      <p className={'directorPage__carousel_text'}>Ventas</p>
                    </div>
                    <div className={'directorPage__carousel_total'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.total_pcompra, 2)}`}</p>
                      <p className={'directorPage__carousel_text'}>Compra</p>
                    </div>
                    <div className={'directorPage__carousel_total'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.credito, 2)}`}</p>
                      <p className={'directorPage__carousel_text'}>Crédito</p>
                    </div>
                    <div className={'directorPage__carousel_total'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.merma, 2)}`}</p>
                      <p className={'directorPage__carousel_text'}>Merma</p>
                    </div>
                    <div className={'directorPage__carousel_gastos'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.gastos, 2)}`}</p>
                      <p className={'directorPage__carousel_text'} style={{ lineHeight: '14px', }}>Gasto a proveedores / préstamos ({ `${ this.number_format((t.gastos / t.total) * 100, 2) }%` })</p>
                      <div className={'directorPage__carousel_progressBar'}>
                        <div style={{ background: '#ff4757', width: `${ this.number_format((t.gastos / t.total) * 100, 2) }%` }}></div>
                      </div>
                    </div>
                    <div className={'directorPage__carousel_gastos'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.gastos_fijos, 2)}`}</p>
                      <p className={'directorPage__carousel_text'} style={{ lineHeight: '14px', }}>Gasto fijo diario ({ `${ this.number_format((t.gastos_fijos / t.total) * 100, 2) }%` })</p>
                      <div className={'directorPage__carousel_progressBar'}>
                        <div style={{ background: '#ff4757', width: `${ this.makePercent(t) }%` }}></div>
                      </div>
                    </div>
                    <div className={'directorPage__carousel_total'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.parciales, 2)}`}</p>
                      <p className={'directorPage__carousel_text'}>Parciales</p>
                    </div>
                    <div className={'directorPage__carousel_total'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.abonos, 2)}`}</p>
                      <p className={'directorPage__carousel_text'}>Abonos</p>
                    </div>
                    <p className={'directorPage__carousel_name'}>{
                      signedIn.id_usuario !== 'wiwi00_adm' ? t.nombre : `Negocio #${e+1}`
                    }</p>
                  </div>
                ))
                }
              </ItemsCarousel>

              <hr />

              <Col sm={12}>
                <Row>
                  <Col sm={12} md={12} lg={6}>
                    <div className="ws-box-content">
                      <h4 className="mb-4">Envíos pendientes ({arrTraspasosPendientes.length})</h4>
                      <div className="table-responsive">
                        <table className="table table-sm table-striped mt-2">
                          <thead>
                            <tr>
                              <th>Sucursal destino</th>
                              <th>Fecha y hora</th>
                              <th>Cantidades</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              arrTraspasosPendientes.map((t,e) => (
                                <tr className="ws__list_identificador" onClick={() => { this.onExpandInfoTraspasoProducto(e) }}>
                                  <td>
                                    <p>{signedIn.id_usuario !== 'wiwi00_adm' ? t.sucursal : `Negocio #${e+1}`}</p>
                                  </td>
                                  <td>
                                    <p style={{ fontSize: '.8rem', }}>{moment(t.created_at).format('DD/MM/YYYY')}</p>
                                    <p style={{ fontSize: '.8rem', }}>{moment(t.created_at).format('HH:mm')}</p>
                                    <TimeAgo
                                      style={{ color: '#444', fontSize: '.8rem', }}
                                      className="__listViewPending_time" date={t.created_at} formatter={formatter}
                                    />
                                  </td>
                                  <td>
                                    <p style={{ fontSize: '.8rem', }}>Productos: {(t.count_productos)}</p>
                                    <p style={{ fontSize: '.8rem', }}>KG: {this.number_format(t.cantidad_envio,2)}</p>
                                  </td>
                                </tr>
                              ))
                            }

                          </tbody>
                        </table>
                        {
                          indexTraspasoView > -1 ? (
                            <div className="table-responsive">
                              <table className="table table-sm">
                                <thead>
                                  <tr>
                                    <th>Nombre producto</th>
                                    <th>KG enviados</th>
                                    <th>Total compra</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {
                                    arrTraspasosPendientes[indexTraspasoView].arrListProductos.map((t,e) => (
                                      <tr className="ws__list_identificador">
                                        <p style={{ fontSize: '.8rem', }}>{t.nombre}</p>
                                        <td style={{ fontSize: '.8rem', }}>{this.number_format(t.cantidad, 2)}</td>
                                        <td style={{ fontSize: '.8rem', }}>${this.number_format(parseFloat(t.cantidad) * parseFloat(t.precio_compra), 2)}</td>
                                      </tr>
                                    ))
                                  }
                                </tbody>
                              </table>
                              {
                                arrTraspasosPendientes[indexTraspasoView].arrListProductos.length > 0 ? (
                                  <p style={{ fontSize: '.8rem', }}>Total: ${this.number_format(( this.makeTotalPCompraProductos(arrTraspasosPendientes[indexTraspasoView]) ),2)}</p>
                                ) : (<p>.</p>)
                              }
                            </div>
                          ) : null
                        }
                      </div>
                      <hr />
                    </div>
                  </Col>
                  <Col sm={12} md={12} lg={6}>
                    <div className="ws-box-content">
                      <h4 className="mb-4">Envíos confirmados/mermas ({arrTraspasosConfirmados.length})</h4>
                      <div className="table-responsive">
                        <table className="table table-sm table-striped mt-2">
                          <thead>
                            <tr>
                              <th>Sucursal</th>
                              <th>Fechas</th>
                              <th>Cantidades</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              indexConfirmadosView === -1 && arrTraspasosConfirmados.map((t,e) => (
                     
                                <tr className="ws__list_identificador" onClick={() => { this.onExpandInfoConfirmadosProductos(e) }}>
                                  <td>
                                    <p style={{ fontSize: '.8rem', }}>{signedIn.id_usuario !== 'wiwi00_adm' ? t.sucursal : `Negocio #${e+1}`}</p>
                                  </td>
                                  <td>
                                    <p style={{ fontSize: '.8rem', fontWeight: '600', }}>Enviado</p>
                                    <p style={{ fontSize: '.8rem', }}>{moment(t.created_at).format('DD/MM/YYYY')}</p>
                                    <p style={{ fontSize: '.8rem', }}>{moment(t.created_at).format('HH:mm:ss')}</p>

                                    <p style={{ fontSize: '.8rem', fontWeight: '600', }}>Recibido</p>
                                    <p style={{ fontSize: '.8rem', }}>{moment(t.date_recibido).format('DD/MM/YYYY')}</p>
                                    <p style={{ fontSize: '.8rem', }}>{moment(t.date_recibido).format('HH:mm:ss')}</p>

                                  </td>
                                  <td>
                                    <p style={{ fontSize: '.8rem', }}>Productos: {(t.count_productos)}</p>
                                    <p style={{ fontSize: '.8rem', }}>KG enviados: {this.number_format(t.cantidad_envio,2)}</p>
                                    <p style={{ fontSize: '.8rem', }}>KG confirmados: {this.number_format(t.cantidad_recibido,2)}</p>
                                    <p style={{ color: `${ parseFloat(t.cantidad_merma) > 0 ? 'red' : '#000'}`, fontSize: '.8rem', }}>KG merma: {this.number_format(t.cantidad_merma,2)}</p>
                                  </td>
                                  <td></td>
                                </tr>
                              ))
                            }

                          </tbody>
                        </table>
                        {
                          indexConfirmadosView > -1 ? (
                            <div className="table-responsive">
                              <button className={'btn btn-secondary'} onClick={() => { this.setState({ indexConfirmadosView: -1, }) }}>Regresar</button>
                              <br />
                              <b>Sucursal: {
                                signedIn.id_usuario !== 'wiwi00_adm'
                                ? arrTraspasosConfirmados[indexConfirmadosView].sucursal
                                : `Negocio`
                                }</b>
                              <Row>
                                <Col>
                                  <p style={{ textAlign: 'center', }}>Enviado</p>
                                  <p style={{ textAlign: 'center', }}>${this.number_format(( this.makeTotalPCompraByOPT(arrTraspasosConfirmados[indexConfirmadosView], 1) ),2)}</p>
                                </Col>
                                <Col>
                                  <p style={{ textAlign: 'center', }}>Confirmado</p>
                                  <p style={{ textAlign: 'center', }}>${this.number_format(( this.makeTotalPCompraByOPT(arrTraspasosConfirmados[indexConfirmadosView], 2) ),2)}</p>
                                </Col>
                                <Col>
                                  <p style={{ textAlign: 'center', }}>Merma</p>
                                  <p style={{ textAlign: 'center', }}>${this.number_format(( this.makeTotalPCompraByOPT(arrTraspasosConfirmados[indexConfirmadosView], 3) ),2)}</p>
                                </Col>
                              </Row>
                              <table className="table table-sm" style={{minWidth:'800px'}}>
                                <thead>
                                  <tr>
                                    <th>Nombre producto</th>
                                    <th>Enviado</th>
                                    <th>Confirmados de recepción</th>
                                    <th>Merma</th>
                                    <th>Observación</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {
                                    arrTraspasosConfirmados[indexConfirmadosView].arrListProductos.map((t,e) => (
                                      <tr className="ws__list_identificador">
                                        <p>{t.nombre}</p>
                                        <td>
                                          <p>KG: {this.number_format(t.cantidad, 2)}</p>
                                          <p>Total: ${this.number_format(parseFloat(t.cantidad) * parseFloat(t.precio_compra), 2)}</p>
                                        </td>
                                        <td>
                                          <p>KG: {this.number_format(t.cantidad_recibido, 2)}</p>
                                          <p>Total: ${this.number_format(parseFloat(t.cantidad_recibido) * parseFloat(t.precio_compra), 2)}</p>
                                        </td>
                                        <td>
                                          <p style={{ color: `${ parseFloat(t.cantidad_merma) > 0 ? 'red' : '#000'}` }}>KG: {this.number_format(t.cantidad_merma, 2)}</p>
                                          <p style={{ color: `${ parseFloat(t.cantidad_merma) > 0 ? 'red' : '#000'}` }}>Total: ${this.number_format(parseFloat(t.cantidad_merma) * parseFloat(t.precio_compra), 2)}</p>
                                        </td>
                                        <td>{t.observacion}</td>
                                      </tr>
                                    ))
                                  }
                                </tbody>
                              </table>
                            </div>
                          ) : null
                        }
                      </div>
                      <hr />
                    </div>
                  </Col>

                </Row>
              </Col>
            </div>

            <Modal
              overlayClassName="Overlay__aplicaciones"
              isOpen={this.state.isOpenGastoFinanciero}
              onRequestClose={() => { this.setState({ isOpenGastoFinanciero: false}) }}
              style={customStyles}
              contentLabel=""
              >
              <div className="modalBody__operador">
                <Row className="modalBody__corte"> 
                  <Col>
                    <h4>Registrar gasto financiero</h4>

                     <div>
                        <div className="form-group">
                          <p style={{ fontSize: '1rem' }}>Ingresa la descripción del gasto</p>
                          <input className={'usersPage__modalNewName'} style={{ margin: 0, }} type={'text'}
                            value={ arrGFinancieroNew.descripcion }
                            onChange={(event) => {
                              arrGFinancieroNew.descripcion = event.target.value;
                              this.setState({ arrGFinancieroNew, })
                            }}
                          />
                        </div>
                        <div className="form-group">
                          <p style={{ fontSize: '1rem' }}>Selecciona el concepto</p>
                          <select className={'ws__list_meta_select'} onChange={ (e) => { arrGFinancieroNew.id_concepto = e.target.value; this.setState({ arrGFinancieroNew, }) }}>
                            <option value={0} disabled selected>Selecciona una opción</option>
                            { arrConceptosGFinancieros.map((t) => (
                              <option value={t.id_concepto}>{t.concepto}</option>
                            )) }
                          </select>
                        </div>
                        <div className="form-group">
                          <p style={{ fontSize: '1rem' }}>Ingresa la cantidad</p>
                          <input className={'usersPage__modalNewName'} style={{ margin: 0, }} type={'text'}
                          value={ arrGFinancieroNew.cantidad }
                          onChange={(event) => {
                            arrGFinancieroNew.cantidad = event.target.value;
                            this.setState({ arrGFinancieroNew, })
                          }}
                        />
                        </div>
                        <div className="form-group">
                          <p style={{ fontSize: '1rem' }}>Ya facturado</p>
                          <button className={'btn btn-secondary'} onClick={() => {
                            arrGFinancieroNew.facturado = !arrGFinancieroNew.facturado;
                            this.setState({ arrGFinancieroNew, });
                          }} >{arrGFinancieroNew.facturado ? 'Si' : 'No'}</button>
                        </div>
                        <div className="form-group">
                          <p style={{ fontSize: '1rem' }}>Forma de pago</p>
                          <select className={'ws__list_meta_select'} onChange={ (e) => { arrGFinancieroNew.forma_pago = e.target.value; this.setState({ arrGFinancieroNew, }) }}>
                            <option value={0} disabled selected>Selecciona una opción</option>
                            <option value={1}>Efectivo</option>
                            <option value={2}>Tarjeta de débito</option>
                            <option value={3}>Tarjeta de crédito</option>
                          </select>
                        </div>

                        <button onClick={ () => { this.onRegisterNewGastoFinanciero()} } className={'btn btn-success'}>Registrar gasto</button>
                        
                      </div>

                  </Col>
                </Row>
              </div>
            </Modal>

            <Modal
              overlayClassName="Overlay__aplicaciones"
              isOpen={this.state.isOpenListFinanciero}
              onRequestClose={() => { this.setState({ isOpenListFinanciero: false}) }}
              style={customStyles}
              contentLabel=""
              >
              <div className="modalBody__operador">
                <Row className="modalBody__corte"> 
                  <Col>
                    <h4>Desglose de gastos</h4>

                    <table>
                      <thead>
                        <tr>
                          <td>Usuario</td>
                          <td>Descripción</td>
                          <td>Concepto</td>
                          <td>Forma de pago</td>
                          <td>Facturado</td>
                          <td>Cantidad</td>
                          <td>Fecha</td>
                        </tr>
                      </thead>

                      <tbody>
                      {
                        arrGastosFinancieros.map((t,e) => (
                          <tr>
                            <td>{t.nombre}</td>
                            <td>{t.descripcion}</td>
                            <td>{t.concepto}</td>
                            <td>{
                              t.forma_pago === 1
                              ? 'Efectivo'
                              : t.forma_pago === 2
                              ? 'Tarjeta de débito'
                              : t.forma_pago === 3
                              ? 'Tarjeta de crédito'
                              : ''
                            }</td>
                            <td>{t.facturado === 1 ? 'SI' : 'NO'}</td>
                            <td>{this.number_format(t.cantidad,2)}</td>
                            <td>{moment(t.created_at).format('DD/MM HH:mm')}</td>
                          </tr>
                        ))
                      }
                      </tbody>
                    </table>

                  </Col>
                </Row>
              </div>
            </Modal>
          </Row>
        </Container>
      </div>
    );
  }

  onRegisterNewGastoFinanciero() {
    let { arrGFinancieroNew, finit, ffin, } = this.state
    const { id_concepto, cantidad, facturado, forma_pago, } = arrGFinancieroNew
    const { signedIn, } = this.props.initState

    if( !id_concepto || !cantidad || !forma_pago ) {
      alert('Por favor, ingresa todos los campos solicitados.');
      return false
    }

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterGastoFinanciero",
      this.headersPOST({ ...arrGFinancieroNew, id_usuario: signedIn.id_usuario, finit, ffin, })
    ).then(response => response.json())
    .then((response) => {
      this.setState({ ...response, isOpenGastoFinanciero: false, })
      alert('Gasto registrado con éxito.')
    })
  }

  onExpandInfoTraspasoProducto(e) {
    if(this.state.indexTraspasoView === e) {
      this.setState({ indexTraspasoView: -1, })
      return false
    }
    let { arrTraspasosPendientes, } = this.state
    this.setState({ indexTraspasoView: e, })
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getProductosByTraspasoGral", this.headersPOST({ id_entrada: arrTraspasosPendientes[e].id_entrada }))
    .then(response => response.json())
    .then((response) => {
      arrTraspasosPendientes[e].arrListProductos = response.list
      this.setState({ arrTraspasosPendientes })
    })
  }

  onExpandInfoConfirmadosProductos(e) {
    if(this.state.indexConfirmadosView === e) {
      this.setState({ indexConfirmadosView: -1, })
      return false
    }
    let { arrTraspasosConfirmados, } = this.state
    this.setState({ indexConfirmadosView: e, })


    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getProductosByTraspasoGral", this.headersPOST({ id_entrada: arrTraspasosConfirmados[e].id_entrada }))
    .then(response => response.json())
    .then((response) => {
      arrTraspasosConfirmados[e].arrListProductos = response.list
      this.setState({ arrTraspasosConfirmados })
    })
  }

  makeTotalPCompraProductos(t) {
    let totalPCompra = 0
    t.arrListProductos.map((t0) => {
      totalPCompra += (parseFloat(t0.precio_compra) * parseFloat(t0.cantidad))
    })
    return totalPCompra
  }

  makeTotalPCompraByOPT(t, opt) {
    let totalPCompra = 0, sum = 0
    t.arrListProductos.map((t0) => {
      if(opt == 1) sum = (parseFloat(t0.precio_compra) * parseFloat(t0.cantidad))
      else if(opt === 2) sum = (parseFloat(t0.precio_compra) * parseFloat(t0.cantidad_recibido))
      else if(opt === 3) sum = (parseFloat(t0.precio_compra) * parseFloat(t0.cantidad_merma))

      totalPCompra += sum
    })
    return totalPCompra
  }

  makePercent(t) {
    const perc = this.number_format((t.gastos_fijos / t.total) * 100, 2)
    return perc > 100 ? 100 : perc;
  }


  makeInfoMetasValles() {
    let cantidad = 0, fijo = 0, compra = 0, venta = 0

    for(var a in this.state.arrHistoryVentas.list) {
      if( this.state.arrHistoryVentas.list[a].id_sucursal !== '5f2067c914482' ) {
        fijo += this.state.arrHistoryVentas.list[a].gastos_fijos
        venta += this.state.arrHistoryVentas.list[a].total
        compra += this.state.arrHistoryVentas.list[a].total_pcompra
      }

      if(a == ( this.state.arrHistoryVentas.list.length - 1 )) {
        return this.number_format((venta - compra) - fijo, 2)
      }

    }

    return 0
    // this.number_format( ((arrHistoryVentas.total + arrHistoryVentas.abonos) - (arrHistoryVentas.total_pcompra)) - arrHistoryVentas.gastos ,2)

  }

  onChangeFiltroVer(t, e) {
    let { arrTableroOptions, arrFiltroVer, isLoading, finit, ffin, valueLarge, } = this.state

    arrFiltroVer.map(( t => t.active = 0) );
    arrFiltroVer[e].active = 1

    if( t.optFiltroVer == 'dia' ) {
      let now = moment( finit );
      finit = now.clone().weekday(1).format('YYYY-MM-DD')
      ffin  = finit
    } else if( t.optFiltroVer == 'semana' ) {
      let now = moment( finit );
      finit = now.clone().weekday(1).format('YYYY-MM-DD')
      ffin  = now.clone().weekday(7).format('YYYY-MM-DD')
    } else if(t.optFiltroVer == 'mes') {
      let now = moment( finit );
      finit  = now.startOf('month').format('YYYY-MM-DD')
      ffin  = now.endOf('month').format('YYYY-MM-DD')
    }

    this.setState({ arrFiltroVer, finit, ffin }, this.getProgreso);
  }

  onInfoBySucursal(t,e) {
    let { tabsArray, arrSucursalSelected } = this.props.initState

    for(var a in tabsArray) {
      tabsArray[a].active = 0
      if( tabsArray[a].index === 2 ) {
        //Sección sucursal
        tabsArray[a].active = 1
      }
    }
    this.props.initsetState({ arrSucursalSelected: {e, t}, tabsArray, })

  }
  makeListProductsBySucursal() {
    const { arrHistoryVentas, indexViewProducts } = this.state
    if(arrHistoryVentas.length === 0) {
      return null
    }

    return (
      <>
        {
          arrHistoryVentas.list.map((t,e) => (
            <Row
              key={`ws_list_compra_${e}`}
              style={{ width: '100%', margin: '0 auto', marginTop: 10, }}
              className="regVentaPage__content"
              onClick={() => { this.setState({indexViewProducts: (indexViewProducts === e ? -1 : e) }) }}
            >
              <div className="regVentaPage__separator"></div>
              <Col className="regVentaPage__listProduct">
                <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}>{t.nombre}</p>
              </Col>
              <Col className="regVentaPage__listPrices" xs={7}>
                <p className="lprices__amount">${ this.number_format( (t.total) , 2) }</p>
              </Col>

              {
                indexViewProducts === e ? (
                <>
                {
                  t.list.map((t0, e0) => (
                    <Row
                      key={`ws_list_product_${e0}`}
                      style={{ width: '80%', margin: '0 auto', marginTop: '0px !important', background: '#fff', }}
                      className="regVentaPage__content"
                    >
                      <div className="regVentaPage__separator"></div>
                      <Col className="regVentaPage__listProduct">
                        <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}><b>{t0.nombre}</b></p>
                        <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}>Hora: {t0.hora}</p>
                      </Col>
                      <Col className="regVentaPage__listPrices" xs={7}>
                        <p className="lprices__amount">${ this.number_format( (t0.venta_pesos) , 2) }</p>
                        <p className="lprices__kg">{ this.number_format(t0.venta_kg, 2) } KG</p>
                      </Col>
                    </Row>
                  ))
                }
                </>
                ) : null
              }

            </Row>
          ))
        }
      </>
    )
  }

  makeListProductsByCategoria() {
    const { arrHistoryVentas, indexViewProducts } = this.state
    if(arrHistoryVentas.length === 0) {
      return null
    }

    return (
      <>
        {
          arrHistoryVentas.map((t,e) => (
            <Row
              key={`ws_list_compra_${e}`}
              style={{ width: '100%', margin: '0 auto', marginTop: 10, }}
              className="regVentaPage__content"
              onClick={() => { this.setState({indexViewProducts: (indexViewProducts === e ? -1 : e) }) }}
            >
              <div className="regVentaPage__separator"></div>
              <Col className="regVentaPage__listProduct">
                <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}>{t.nombre}</p>
              </Col>
              <Col className="regVentaPage__listPrices" xs={7}>
                <p className="lprices__amount">${ this.number_format( (t.total) , 2) }</p>
              </Col>

              {
                indexViewProducts === e ? (
                <>
                {
                  t.list.map((t0, e0) => (
                    <Row
                      key={`ws_list_product_${e0}`}
                      style={{ width: '80%', margin: '0 auto', marginTop: '0px !important', background: '#fff', }}
                      className="regVentaPage__content"
                    >
                      <div className="regVentaPage__separator"></div>
                      <Col className="regVentaPage__listProduct">
                        <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}><b>{t0.nombre}</b></p>
                        <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}>Hora: {t0.hora}</p>
                      </Col>
                      <Col className="regVentaPage__listPrices" xs={7}>
                        <p className="lprices__amount">${ this.number_format( (t0.venta_pesos) , 2) }</p>
                        <p className="lprices__kg">{ this.number_format(t0.venta_kg, 2) } KG</p>
                      </Col>
                    </Row>
                  ))
                }
                </>
                ) : null
              }

            </Row>
          ))
        }
      </>
    )
  }

  makeListProducts() {
    const { arrHistoryVentas } = this.state
    if(arrHistoryVentas.length === 0) {
      return null
    }

    return (
      <>
        {
          arrHistoryVentas.map((t,e) => (
            <Row
              key={`ws_list_compra_${e}`}
              style={{ width: '100%', margin: '0 auto', marginTop: 10, }}
              className="regVentaPage__content"
            >
              <div className="regVentaPage__separator"></div>
              <Col className="regVentaPage__listProduct">
                <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}><b>{t.nombre}</b></p>
                <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}>{t.nombre_sucursal}</p>
                <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}>Hora: {t.hora}</p>
              </Col>
              <Col className="regVentaPage__listPrices" xs={7}>
                <p className="lprices__amount">${ this.number_format( (t.venta_pesos * t.venta_kg) , 2) }</p>
                <p className="lprices__kg">{ this.number_format(t.venta_kg, 2) } KG</p>
              </Col>
            </Row>
          ))
        }
      </>
    )
  }

  getProgressMeta() {
    let utilidad = this.getAmountByDay('utilidad')
    let meta = 0

    if(utilidad !== 0) {
      utilidad = utilidad.replace('$', '').replace(',', '')
      meta = ((utilidad / 15000) * 100)
    }

    return {
      porc: (meta > 100 ? 100 : meta) + '%',
      val: meta
    }
  }

  goToDay(data) {
    const { date, arrDiasVenta, finit, ffin, } = this.state
      let d = new Date(date)

    setTimeout(() => {
      if(this.getAmountByDay('venta') !== '0.00' || this.state.date === moment().format('YYYY-MM-DD')) {
        fetch(this.getURLByOPT('getListadoVentaByDiaV2'), this.headersPOST({ date: this.state.date, groupBy: this.state.groupBy, finit, ffin, ...data }))
        .then(response => response.json())
        .then((response) => {
          let { arrHistoryVentas, arraySucursales, arrDiasVenta, arrDiasGasto, confirmados, pendientes,
            arrGastosFinancieros, arrConceptosGFinancieros,
          } = response
          let { total_pesos, total_kg, total_pesos_before, total_gasto_mes, total_gasto_proveedor, total_venta_mes, } = arrDiasVenta

          this.setState({
            pleaseUpdate: 0,
            arrHistoryVentas,
            arraySucursales,
            arrDiasVenta: arrDiasVenta.array,
            arrDiasGasto: arrDiasGasto.array,
            totalVentas: {
              kg: total_kg,
              pesos: total_pesos,
              pesosMesAnterior: total_pesos_before,

              total_gasto_mes,
              total_gasto_proveedor,
              total_venta_mes,

            },
            totalGastos: { gastos: arrDiasGasto.total_gastos, },
            isLoading: false,
            arrTraspasosPendientes: pendientes,
            arrTraspasosConfirmados: confirmados,
            arrGastosFinancieros,
            arrConceptosGFinancieros,
          })

        }).catch((error) => console.log(error));

      }

    }, 500)

  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

  getColorByIndex(e) {
    const color = ['#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3','#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3']
    return color[e]
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://hg.wsoft.com.mx/REST/controllers/${PHP}?opt=${opt}`
  }

};

export default withRouter(MainProgresoPage)